import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/rawan/Header";
import { Footer } from "@/components/rawan/Footer";
import { EditableStaticPage } from "@/components/rawan/EditableStaticPage";

export const Route = createFileRoute("/faq")({
  head: () => ({
    meta: [
      { title: "الأسئلة الشائعة — Rawan UI" },
      { name: "description", content: "إجابات على الأسئلة الأكثر شيوعاً حول استخدام موقع Rawan UI." },
      { property: "og:title", content: "FAQ — Rawan UI" },
      { property: "og:description", content: "Frequently asked questions about Rawan UI." },
    ],
  }),
  component: FaqPage,
});

function FaqPage() {
  return (
    <div className="min-h-dvh flex flex-col">
      <Header />
      <main className="flex-1 container mx-auto px-4 py-12 max-w-3xl">
        <EditableStaticPage
          pageKey="faq"
          titleAr="الأسئلة الشائعة"
          titleEn="Frequently Asked Questions"
          titleFr="Questions fréquentes"
          defaultParagraphsAr={[
            "## ما هو Rawan UI؟\n\nهو قالب عصري لعرض **الأفلام والمسلسلات**، يدعم 3 لغات (العربية، الإنجليزية، الفرنسية)، ومتوافق مع الأجهزة المختلفة.",
            "## هل المحتوى مستضاف على هذا الموقع؟\n\nلا. الموقع لا يستضيف أي ملفات — جميع الروابط هي إحالات لمصادر طرف ثالث. راجع [إخلاء المسؤولية](/disclaimer) لمزيد من التفاصيل.",
            "## كيف أغيّر لغة الواجهة؟\n\nاضغط على زر **اللغة** في الأعلى ثم اختر العربية أو English أو Français. سيتم حفظ اختيارك تلقائياً.",
            "## كيف أضيف عملاً إلى قائمتي؟\n\n1. افتح صفحة الفيلم أو المسلسل.\n2. اضغط على أيقونة **المفضلة** بجوار العنوان.\n3. يمكنك مراجعة قائمتك في صفحة *حسابي*.",
            "## كيف أبلّغ عن مشكلة؟\n\nراسلنا عبر [صفحة الاتصال](/contact) مع وصف موجز للمشكلة، وسنرد في أقرب وقت.",
          ]}
          defaultParagraphsEn={[
            "## What is Rawan UI?\n\nA modern template for showcasing **movies and series**, with full Arabic / English / French support and responsive design.",
            "## Do you host any content on this site?\n\nNo. We don't host any files — every link points to a third-party source. See the [disclaimer](/disclaimer) for details.",
            "## How do I change the interface language?\n\nClick the **language** switcher at the top and pick Arabic, English or French. Your choice is saved automatically.",
            "## How do I add a title to my list?\n\n1. Open the movie or series page.\n2. Tap the **favorite** icon next to the title.\n3. Find your list under *My account*.",
            "## How do I report an issue?\n\nUse the [contact page](/contact) with a short description and we'll get back to you.",
          ]}
          defaultParagraphsFr={[
            "## Qu'est-ce que Rawan UI ?\n\nUn modèle moderne pour présenter **films et séries**, avec un support complet en arabe / anglais / français et un design responsive.",
            "## Hébergez-vous du contenu sur ce site ?\n\nNon. Nous n'hébergeons aucun fichier — chaque lien renvoie vers une source tierce. Voir l'[avertissement](/disclaimer).",
            "## Comment changer la langue ?\n\nCliquez sur le sélecteur de **langue** en haut et choisissez Arabe, Anglais ou Français. Votre choix est sauvegardé automatiquement.",
            "## Comment ajouter un titre à ma liste ?\n\n1. Ouvrez la page du film ou de la série.\n2. Cliquez sur l'icône **favori** à côté du titre.\n3. Retrouvez votre liste dans *Mon compte*.",
            "## Comment signaler un problème ?\n\nUtilisez la [page de contact](/contact) avec une courte description, nous vous répondrons rapidement.",
          ]}
        />
      </main>
      <Footer />
    </div>
  );
}
